// extracted by mini-css-extract-plugin
export var optionGrid = "_5j-7";
export var optionList = "_5j-6";
export var questionsBlock = "_5j-9";
export var spacer = "_5j-5";
export var stepCenteredContent = "_5j-3";
export var stepInner = "_5j-0";
export var stepInnerFullWidth = "_5j-1";
export var stepInnerLockScroll = "_5j-2";
export var stepTransitionFrame = "_5j-4";
export var welcomeBlock = "_5j-8";